import React from 'react';
import { Link } from 'react-router-dom';
import './Legal.css';

function PrivacyPolicy() {
  return (
    <div className="legal-page">
      <div className="legal-card">
        <div className="legal-header">
          <h1>Monnaify Gizlilik Politikasi</h1>
          <p className="legal-meta">Son guncelleme: 2026-04-04</p>
        </div>

        <p>
          Monnaify, ev arkadaslari, aileler ve arkadas gruplari icin ortak harcama
          takibini kolaylastiran bir uygulamadir. Bu gizlilik politikasi; mobil ve
          web uygulamalarimizi kullandiginizda hangi verileri topladigimizi, nasil
          kullandigimizi ve korudugumuzu aciklar.
        </p>

        <h2>Toplanan Veriler</h2>
        <ul>
          <li>Hesap bilgileri: ad, e-posta ve sifre (sifreler hashlenmis olarak saklanir).</li>
          <li>Uygulama icerigi: harcama kayitlari, ev/grup bilgileri, uye listeleri.</li>
          <li>Kimlik dogrulama: Google veya Apple ile giris yaparsaniz, bu saglayicilardan gelen temel hesap bilgileri.</li>
        </ul>

        <h2>Verilerin Kullanimi</h2>
        <ul>
          <li>Hesabinizi olusturmak ve giris islemlerini yapmak.</li>
          <li>Harcama takibi, ozet ve hesaplasma gibi temel uygulama ozelliklerini sunmak.</li>
          <li>Destek taleplerini yanitlamak ve guvenligi saglamak.</li>
        </ul>

        <h2>Veri Paylasimi</h2>
        <p>
          Kisisel verilerinizi satmayiz. Veriler yalnizca hizmeti sunmak icin gerekli
          teknik altyapi saglayicilariyla (or. barindirma ve veritabani hizmetleri)
          paylasilabilir.
        </p>

        <h2>Veri Saklama</h2>
        <p>
          Veriler, hizmetin dogru calismasi icin sunucularimizda saklanir. Hesabinizi
          silmek veya verilerinizin kaldirilmasini istemek icin bizimle iletisime gecin.
        </p>

        <h2>Guvenlik</h2>
        <p>
          Veriler aktarilirken HTTPS kullanilir. Yetkisiz erisimi onlemek icin teknik
          ve idari onlemler aliriz.
        </p>

        <h2>Cocuklarin Gizliligi</h2>
        <p>
          Uygulama 13 yas altindaki cocuklara yonelik degildir.
        </p>

        <h2>Iletisim</h2>
        <p>
          Gizlilikle ilgili sorulariniz icin bize ulasin: <a href="mailto:support@monnaify.app">support@monnaify.app</a>
        </p>

        <div className="legal-actions">
          <Link to="/support">Destek</Link>
          <Link to="/">Giris</Link>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
